import { third, list } from 'components/CameraModelSelector/style'
import { COLORS } from 'helpers/globals'

export default {
  container: {
    ...third
  },
  expansionContainer: {
    ...third,
    width: '50%'
  },
  list,
  details: {
    ...third,
    color: 'black',
    width: '100%',
    padding: '.7rem',
    position: 'relative',
    '& img': {
      maxHeight: '10rem',
      maxWidth: '10rem',
      marginBottom: '1rem'
    },
    '& h4': {
      marginBottom: '.5rem'
    }
  },
  selectModelButton: {
    width: '100%',
    fontSize: '1.4rem',
    borderRadius: '.5rem',
    '& svg': {
      marginRight: '.6rem'
    }
  },
  modelCountDisplay: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'black',
    paddingTop: '22.5%',
    textAlign: 'center',
    lineHeight: '3rem',
    fontSize: '2.2rem'
  },
  missingModelButton: {
    fontSize: '1.8rem',
    fontWeight: 400,
    color: 'white',
    background: COLORS.primary,
    padding: '.4rem .8rem',
    borderRadius: '.5rem',
    '&:hover': {
      color: 'white',
      background: COLORS.primaryHover
    }
  },
  break: {
    margin: '3rem 5% !important',
    width: '90%'
  }
}




// WEBPACK FOOTER //
// ./src/components/DoorControllerModelSelector/ModelDetails/style.js